"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";

import useSignOut from "../../../../hooks/useSignOut";

/**
 * If there is an error with the refresh tokens for this session, we want to sign out the user.
 */
export default function MonitorSession() {
    const session = useSession();

    const sessionError = session.data?.error;
    const signOut = useSignOut();

    useEffect(() => {
        if (sessionError === "RefreshAccessTokenError") {
            signOut();
        }
    }, [sessionError, signOut]);

    return null;
};
